import React, { useContext, useState } from "react";
import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { AuthContext } from "./context/AuthContext";
import "./App.css";
import Buchsuche from "./pages/Buchsuche";
import Mitglieddaten from "./pages/Mitglieddaten";
import MitgliedVerwaltung from "./pages/MitgliedVewaltung";
import BuchVerwaltung from "./pages/BuchVerwaltung";
import { SelectedBookProvider } from "./context/SelectedBookContext";
import Startseite from "./pages/Startseite";
import { LayoutGroup } from "framer-motion";

function App() {
  const authContext = useContext(AuthContext)!;
  const isLoggedIn = !!authContext.user?.username;
  const isAdmin = authContext.user?.roles?.includes("ADMIN");
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <SelectedBookProvider>
      <BrowserRouter>
        <nav className="navbar">
          <div className="nav-logo">
            <Link to="/">LOGO</Link>
          </div>
          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <Link to="/startseite" className="nav-btn">
              Startseite
            </Link>

            <Link to="/buchsuche" className="nav-btn">
              Buchsuche
            </Link>
            {isLoggedIn && (
              <Link to="/mitglieddaten" className="nav-btn">
                Mitglieddaten
              </Link>
            )}
            {isAdmin && (
              <>
                <Link to="/mitgliedverwaltung" className="nav-btn">
                  Mitgliedverwaltung
                </Link>
                <Link to="/buchverwaltung" className="nav-btn">
                  Buchverwaltung
                </Link>
              </>
            )}
            <div className="nav-auth">
              {isLoggedIn ? (
                <>
                  <span className="username">
                    Hi, {authContext.user?.username}
                  </span>
                  <button className="logout-btn" onClick={authContext.logout}>
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="log-btns">
                    Login
                  </Link>
                  <Link to="/register" className="log-btns">
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>

          <div className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>

        <LayoutGroup>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/startseite" element={<Startseite />} />
            <Route path="/buchsuche" element={<Buchsuche />} />
            <Route
              path="/mitglieddaten"
              element={
                isLoggedIn && authContext.user ? (
                  <Mitglieddaten />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/mitgliedverwaltung"
              element={
                isLoggedIn && isAdmin ? (
                  <MitgliedVerwaltung />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/buchverwaltung"
              element={
                isLoggedIn && isAdmin ? (
                  <BuchVerwaltung />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            {/* Wenn du später etwas schützen willst */}
            {/* <Route path="/" element={
          auth.user ? <Dashboard /> : <Navigate to="/login" />
        }/> */}
          </Routes>
        </LayoutGroup>
      </BrowserRouter>
    </SelectedBookProvider>
  );
}

export default App;
